import React, { useState, useEffect } from 'react';

import Box from '../history/bonus/Box';
import Card from './Card';
import store from '@/stores';
import { getLocaleWordContent } from '@/utils/language.util';

function onChartCreator() {
    // const searchParams = { code: '' };
    console.log('........', store.getState().navigate.get('baseUrl'));
    return `${store.getState().navigate.get('baseUrl')}/api/chart/tree_refer.php`;
}
function onChartCreator2() {
    // const searchParams = { code: '' };
    console.log('........', store.getState().navigate.get('baseUrl'));
    return `${store.getState().navigate.get('baseUrl')}/api/chart/tree_sponsor.php`;
}

export default function Chart() {
    const [tab, setTab] = useState('');
    const [tit, setTit] = useState('');
    const [txt, setTxt] = useState('');
    const param = window.location.hash.split('?')[1] ? window.location.hash.split('?')[1] : 'tab1';

    const fetchBusinesses = () => {
        if (param === 'tab1') {
            setTab('tab1');
            setTit(getLocaleWordContent('추천조직도 페이지'));
            setTxt(getLocaleWordContent('추천조직도'));
        } else if (param === 'tab2') {
            setTab('tab2');
            setTit(getLocaleWordContent('후원조직도 페이지'));
            setTxt(getLocaleWordContent('후원조직도'));
        }
    };
    useEffect(fetchBusinesses, [param]);

    return (
        <>
            <h2 className="inner text-center">{tit}</h2>
            <div className="bg_balance_left">
                <Box />
                <div className="log_box">
                    <h2 className="strong">{txt}</h2>
                    <div className="org-tree text-center">
                        {tab === 'tab1' ? <Card onChartCreator={onChartCreator} /> : null}
                        {tab === 'tab2' ? <Card onChartCreator={onChartCreator2} /> : null}
                    </div>
                </div>
            </div>
        </>
    );
}
